const initialState = {
    value: ''
}

export const statusBarTransaksi = (state = initialState, actions) => {
    if (actions.type === 'SET_STATUS_BAR') {
        return {
            ...state,
            value: actions.value
        }
    }
    return state
}